<script setup lang="ts">
    import { Company } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import Delete from '@/components/Delete.vue';
    import EditCompany from '@/components/companies/EditCompany.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        company: Company;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="company">
        <EditCompany :company="company" />
        <Delete
            v-if="hasPermission(Permission.COMPANIES_DELETE)"
            :route="route('v2.companies.destroy', { id: company.id })"
            :query-key="[QueryKey.COMPANIES]"
            success-message="companies.deleted"
            error-message="companies.delete.error"
            continue-button-text="companies.js.delete.title"
            header="companies.js.delete.header"
        >
            <template #description>
                <p class="mt-2">{{ $t('companies.js.delete.will_delete') }}</p>

                <ul class="ml-5 list-disc">
                    <li>{{ $t('companies.js.delete.deleted_rows.users') }}</li>
                    <li>{{ $t('companies.js.delete.deleted_rows.payrolls') }}</li>
                    <li>{{ $t('companies.js.delete.deleted_rows.pay_slips') }}</li>
                    <li>{{ $t('companies.js.delete.deleted_rows.employees') }}</li>
                </ul>

                <p class="mt-4 font-semibold">
                    {{ $t('companies.js.delete.cannot_be_undone') }}
                </p>
            </template>
        </Delete>
    </DataTableActions>
</template>
